module.exports = __webpack_public_path__ + "30c939e87c6f3d688afba6004b2e2c9e.svg";